<header class="fixed w-full top-0 z-40">
  <div class="desktop:h-14 bg-white flex justify-center items-center">
    @if (logoUrl()) {
      <sc-button
        variant="text"
        [padding]="false"
        [ariaLabel]="'Go to Let’s go Mobile homepage'"
        (clicked)="handleLogoRedirect()"
        class="w-fit"
      >
        <img [src]="logoUrl().image.url | scCmsImage" alt="" />
      </sc-button>
    }
  </div>
  @if (!isPortingBlocked()) {
    <div class="bg-primaryRed">
      <div class="container">
        <div class="flex h-[94px]" [ngClass]="hideNav() ? 'justify-end' : 'justify-between'">
          @if (!hideNav()) {
            <nav
              class="px-3.5 flex gap-7 items-center text-white header-links"
              [class.gap-x-36]="isB2B()"
            >
              @for (link of links(); track $index) {
                <a
                  [routerLink]="link.path"
                  routerLinkActive="text-black bg-white font-bold"
                  class="flex flex-col w-[134px] h-[68px] py-2 items-center cursor-pointer rounded-full hover:text-black hover:bg-white hover:font-bold outline-none focus-visible:ring-2 ring-blue-500 ring-offset-0"
                >
                  <sc-svg [name]="link.icon" size="size-[28px]"></sc-svg>
                  <div class="mt-1 uppercase text-xs text-inherit">
                    {{ link.label | scTranslate | async }}
                  </div>
                </a>
              }

              @if (!isB2B()) {
                <a
                  routerLink="/faq"
                  routerLinkActive="text-black bg-white font-bold"
                  class="flex flex-col w-[134px] h-[68px] py-2 items-center cursor-pointer rounded-full hover:text-black hover:bg-white hover:font-bold outline-none focus-visible:ring-2 ring-blue-500 ring-offset-0"
                >
                  <sc-svg name="service-helpful-bold" size="size-7"></sc-svg>
                  <div class="mt-1 uppercase text-xs text-inherit">
                    {{ 'navigation.service' | scTranslate | async }}
                  </div>
                </a>
              }
            </nav>
          }

          <sc-mini-profile></sc-mini-profile>
        </div>
      </div>
    </div>
  }
</header>
